import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { APIProvider } from '@vis.gl/react-google-maps';
import Home from './Home';
import EventsPage from './EventsPage';
import PrivacyPolicy from './PrivacyPolicy';
import Terms from './Terms';
import { AuthProvider } from './context/AuthContext';
import { trackPageView } from './lib/analytics';

function AnalyticsTracker() {
  const location = useLocation();

  React.useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(path);
  }, [location]);

  return null;
}

const App = () => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  return (
    <APIProvider
      apiKey={apiKey}
      onLoad={() => console.log('Maps API has loaded.')}
      onError={(error) => console.error('Error loading Maps API:', error)}
    >
      <AuthProvider>
        <Router>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<EventsPage />} />
            {/* <Route path="/promoter" element={<PromoterPortal />} /> */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
            <Route path="/terms" element={<Terms />}></Route>
          </Routes>
        </Router>
      </AuthProvider>
    </APIProvider>
  );
};

export default App;
